import i18n from 'i18next';
// import { initReactI18next } from 'react-i18next';
// import HttpBackend from 'i18next-http-backend';

// const storedLang = localStorage.getItem('i18nextLng');
// const browserLang = storedLang || navigator.language || navigator.languages?.[0] || 'fr';
// const supported = ['fr', 'en'];
// const shortLang = browserLang.split('-')[0]; // "fr"
// const initialLang = supported.includes(shortLang) ? shortLang : 'fr';

// i18n
//   .use(HttpBackend)
//   .use(initReactI18next)
//   .init({
//     lng: initialLang,
//     fallbackLng: 'fr',
//     supportedLngs: ['fr', 'en'],
//     keySeparator: '.',
//     debug: import.meta.env.DEV,
//     backend: {
//       loadPath: '/locales/{{lng}}/{{ns}}.json'
//     },

//     ns: ['translation', 'brl'],
//     defaultNS: 'translation'
//   });

export default i18n;
